import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "bootstrap/dist/css/bootstrap.min.css";
import "./header.css";
import { UserAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";

type HeaderProps = {
  logo: any;
};

const Header = (props: HeaderProps) => {
  const { user } = UserAuth();
  const navigate = useNavigate();

  return (
    <Navbar expand="sm" className="bg-body-tertiary justify-content-center">
      <Container>
        <Navbar.Brand href="/home">
          <img src={props.logo} alt="QR Sharp Logo" className="navbar__logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="navbar-expand-sm">
            <Nav.Link href="/home#features">Features</Nav.Link>
            <Nav.Link href="/home#pricing">Pricing</Nav.Link>
            <Nav.Link href="/home#faq">FAQ</Nav.Link>
            <Nav.Link href="/help">Support</Nav.Link>
            <Nav.Link href="#">Blog</Nav.Link>
            {user ? (
              <Nav.Link href="/dashboard" className="navbar__cta">
                Dashboard
              </Nav.Link>
            ) : (
              <Nav.Link
                onClick={() => navigate("/signin")}
                className="navbar__cta"
              >
                Login
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
